export default __webpack_public_path__ + "static/media/backgroun_acompanhamento.0c29364a.png";